import Vue from 'vue'
import moment from 'moment'

// example output: moment(new Date()).format('HH:mm') - "16:33"
Vue.filter('time', function(date) {
    const md = moment(date)
    if (!date || !md) return ''

    return md.format('HH:mm')
})

// example output: moment(new Date()).format('D MMMM YYYY') - "28 October 2019"
Vue.filter('dayFull', function(date) {
    const md = moment(date)
    if (!date || !md) return ''

    return md.format('D MMMM YYYY')
})

// example output: moment(new Date()).format('D MMMM YY') - "28.10.19"
Vue.filter('dayFullNumbers', function(date) {
    const md = moment(date)
    if (!date || !md) return ''

    return md.format('DD.MM.YY')
})

// example output: moment(new Date()).format("DD.MM.YYYY, HH:mm") - "16:34:20"
Vue.filter('timeFull', function(date) {
    const md = moment(date)
    if (!date || !md) return ''

    return md.format('HH:mm:ss')
})

// example output: moment(new Date()).format("DD.MM") - "28.10"
Vue.filter('day', function(date) {
    const md = moment(date)
    if (!date || !md) return ''

    return md.format('DD.MM')
})

Vue.filter('YearMonthDay', function(date) {
    const md = moment(date)
    if (!date || !md) return ''

    return md.format('YYYY.MM.DD')
})
